import { DialogContent, DialogTitle, IconButton, List, ListItem, ListItemIcon, ListItemText, Stack, TextField, Typography, alpha } from "@mui/material";
import { CPage, CPageTitle, CSection } from "../components/cr.ui.page";
import { useReport } from "../components/report";
import { ULine, UMargin, URow, USection } from "../common/ui.page";
import { GREY, INFO_COLOR, MAIN_COLOR, MAIN_COLOR_ACTIVE, SECONDARY_COLOR, WARN_COLOR, WHITE } from "../style/theme";
import { UButton, UListItemButton } from "../common/ui.buttons";
import { useEffect, useState } from "react";
import { CIconDice, CUnitBox, CUnitBoxName, CUnitCompText, CUnitShowDetailsButton } from "../components/cr.ui.unit";
import { Add, Remove } from "@mui/icons-material";
import SubjectIcon from '@mui/icons-material/Subject';
import { UIcon } from "../common/ui.icon";
import { RP_COLOR } from "../components/cr.ui.requisition";
import { UNIT_SORT, UNIT_XP_PERC } from "../components/unit";
import { UDialgoCloseIcon, UDialog } from "../common/ui.dialog";
import { BATTLE_SCARS } from "../components/unit.scars";
import { ExtReportUnitKills, UnitList } from "../components/cr.ui.report";
import { CUnitListContainer } from "../components/cr.ui.order";

export function PageReport() {
    const report = useReport()

    const match = report.match;

    return <CPage>
        <Stack spacing={2} sx={{ paddingTop: 4 }}>
            <USection>
                <Typography variant="h5" color={GREY[700]}>Match Report</Typography>
                <Typography>
                    Riporta i risultati della partita
                </Typography>
            </USection>

            <USection>
                <Typography>{match.name}</Typography>
                <Typography sx={{ color: GREY[800], fontSize: 12 }}>{new Date(match.date).toLocaleDateString('it-IT')}</Typography>
            </USection>

            {match.winner && <CSection>
                <WinnerInfo />
            </CSection>}

            <CSection>

                <UMargin>
                    <UnitDeaths />
                </UMargin>
            </CSection>

            <CSection>

                <UMargin>
                    <UnitKills />
                </UMargin>
            </CSection>

            <ExtReportUnitKills />

            <CSection>

                <UMargin>
                    <UnitGlory />
                </UMargin>
            </CSection>

            <CSection>

                <UMargin>
                    <UnitXp />
                </UMargin>
            </CSection>

            {report.unitRewards.length > 0 && <CSection>
                <UMargin>
                    <UnitRewardList />
                </UMargin>
            </CSection>}

            <USection>
                <CompleteReportButton />
            </USection>
        </Stack>



    </CPage>
}

function UnitDeaths() {
    const report = useReport()
    const hasDeath = report.deaths.length > 0;
    return <Stack>
        <Typography sx={{ fontWeight: 600 }}>Sopravvissute</Typography>
        <Typography sx={{ color: GREY[800] }}>Seleziona le unità sopravvissute</Typography>
        <List>
            <UnitList Component={UnitDeathSelection} />
        </List>
        {hasDeath && <>
            <Typography sx={{ color: GREY[800] }}>Riporta eventuali Ferite di Guerra</Typography>
            <List>
                <UnitList filter={u => report.deaths.includes(u.id)} Component={UnitScar} />
            </List>
        </>}
    </Stack>
}

function UnitKills() {
    const report = useReport()
    return <Stack>
        <Typography sx={{ fontWeight: 600 }}>Uccisioni</Typography>
        <Typography sx={{ color: GREY[800] }}>Seleziona le uccisioni effettuate dalle tue unità</Typography>
        <List>
            <UnitList Component={UnitKillsCounter} />
        </List>
    </Stack>
}

function UnitGlory() {
    const report = useReport()
    return <CUnitListContainer>
        <URow>
            <Typography sx={{ fontWeight: 600 }}>Destinato alla Grandezza</Typography>
            <CUnitShowDetailsButton sx={{ lineHeight: 1 }} />
        </URow>
        <Typography sx={{ color: GREY[800] }}>Seleziona {report.match.army.maxMarks} unità destinate alla Grandezza (+3 XP)</Typography>
        <List>
            <UnitList filter={u => u.xp >= 0} Component={UnitMarkSelection} />
        </List>
    </CUnitListContainer>
}

function UnitXp() {
    const report = useReport()
    return <CUnitListContainer>
        <URow>
            <Typography sx={{ fontWeight: 600 }}>XP Aggiuntivi</Typography>
            <CUnitShowDetailsButton sx={{ lineHeight: 1 }} />
        </URow>
        <Typography sx={{ color: GREY[800] }}>Segna eventuali Punti Esperienza aggiuntivi guadagnati durante la missione</Typography>
        <List sx={{ flex: 1 }}>
            <UnitList filter={u => u.xp >= 0} Component={UnitXpCounter} />
        </List>
    </CUnitListContainer>
}

function UnitRewardList(props) {
    const report = useReport()

    return <List>
        {report.unitRewards.map(r => <UnitReward reward={r} key={r.id} />)}
    </List>
}
function UnitReward(props) {
    const report = useReport()
    const { reward } = props;

    function onSelect(uid, val) {
        report.assignUnitReward(reward.id, uid, val)
    }


    return <Stack>
        <Typography sx={{ fontWeight: 600, color: RP_COLOR }}>{reward.name}</Typography>
        <Typography sx={{ color: GREY[800], whiteSpace: 'pre-wrap', }}>{reward.description}</Typography>
        <List>
            <UnitList
                setSelected={onSelect}
                selected={reward.selected}
                filter={u => reward.assignableUnits.includes(u.id)}
                Component={UnitRewardSelection} />
        </List>
    </Stack>
}

function UnitScar(props) {
    const { unit } = props;
    const report = useReport()
    const currScar = report.scars.filter(s => s.id === unit.id)
    const scar = currScar.length > 0 ? currScar[0] : null
    const hasScar = Boolean(scar)

    function updScar(scar) {
        if (!scar) {
            report.setScar(unit.id, null)
        } else {
            report.setScar(unit.id, {
                id: unit.id,
                name: scar.name,
                description: scar.description
            })
        }
    }

    return <CUnitBox
        color1={hasScar ? WARN_COLOR : GREY[500]}
        color2={hasScar ? alpha(WARN_COLOR, 0.3) : GREY[100]}
        unit={unit}
        Component={ListItem}>
        <Stack spacing={2}>
            <CUnitBoxName unit={unit} />
            {scar && <Stack>
                <Typography sx={{ fontWeight: 600 }}>{scar.name}</Typography>
                <Typography sx={{ fontSize: 12, whiteSpace: 'pre-wrap', }}>{scar.description}</Typography>
            </Stack>}
            <AddBattleScarButton
                scar={scar}
                setScar={updScar}
                unit={unit} />
        </Stack>
    </CUnitBox>

}

function AddBattleScarButton(props) {
    const { unit, scar, setScar } = props;
    const scars = BATTLE_SCARS
    const dices = Object.keys(BATTLE_SCARS)
    const currScars = unit.scars.map(s => s.name)

    return <UDialog button={<UButton color="warning">Imposta Ferita di Guerra</UButton>}>
        <DialogTitle><ULine>
            <Typography>Ferita di guerra - {unit.name || unit.unitType}</Typography>
            <UDialgoCloseIcon />
        </ULine>
        </DialogTitle>
        <DialogContent>
            {dices.map(d => <UListItemButton
                onClick={() => (scar && scar.name === scars[d].name) ? setScar(null) : setScar(scars[d])}
                selected={scar && scar.name === scars[d].name}
                disabled={currScars.includes(scars[d].name) || (scar && scar.name !== scars[d].name)}
                key={d}>
                <ListItemIcon>
                    <CIconDice dice={d} />
                </ListItemIcon>
                <ListItemText
                    primary={scars[d].name}
                    secondary={scars[d].description}
                />
            </UListItemButton>)}
        </DialogContent>
    </UDialog>
}

function UnitDeathSelection(props) {
    const { unit } = props;
    const report = useReport()
    const death = report.deaths.includes(unit.id)

    return <CUnitBox
        color2={GREY[200]}
        onClick={() => report.setDeath(unit.id, !death)}
        selected={!death}
        unit={unit}
        Component={UListItemButton}>
        <Stack>
            <CUnitBoxName unit={unit} />
        </Stack>
    </CUnitBox>

}

function UnitKillsCounter(props) {
    const { unit } = props;
    const report = useReport()
    const [kills, setKills] = useState(0)

    useEffect(() => {
        report.updateKills(unit.id, kills)
    }, [kills])

    return <CUnitBox
        color1={SECONDARY_COLOR}
        color2={'transparent'}
        unit={unit}
        Component={ListItem}>
        <Stack sx={{ flex: 1 }}>
            <CUnitBoxName unit={unit} />
        </Stack>
        <Stack direction="row" alignItems="center">
            <IconButton onClick={() => { if (kills > 0) { setKills(kills - 1) } }}>
                <Remove />
            </IconButton>
            <Typography sx={{ fontSize: 16, fontWeight: 600, color: kills > 0 ? SECONDARY_COLOR : GREY[800], width: 20, textAlign: 'center' }}>
                {kills}
            </Typography>
            <IconButton onClick={() => { setKills(kills + 1) }}>
                <Add />
            </IconButton>
        </Stack>
    </CUnitBox >

}


function UnitMarkSelection(props) {
    const { unit } = props;
    const report = useReport()
    const marked = report.marked.includes(unit.id)
    const maxed = report.match.army.maxMarks <= report.marked.length;

    return <CUnitBox
        percXp={UNIT_XP_PERC(unit.xp)}
        color1={MAIN_COLOR}
        color2={alpha(MAIN_COLOR, 0.3)}
        onClick={() => report.setMarked(unit.id, !marked)}
        selected={marked}
        unit={unit}
        disabled={maxed && !marked}
        Component={UListItemButton}>
        <Stack sx={{ flex: 1 }}>
            <CUnitBoxName unit={unit} />
            {false && <CUnitCompText className="secondary-text" sx={{ fontSize: 12, color: GREY[700], paddingTop: 1, fontWeight: 500 }} comp={unit.composition} />}
        </Stack>
    </CUnitBox>
}

function UnitRewardSelection(props) {
    const { unit, selected, setSelected, maxed } = props;

    return <CUnitBox
        color1={MAIN_COLOR}
        color2={alpha(MAIN_COLOR, 0.3)}
        onClick={() => setSelected(unit.id, selected !== unit.id)}
        selected={selected === unit.id}
        unit={unit}
        disabled={selected !== unit.id && Boolean(selected)}
        Component={UListItemButton}>
        <Stack sx={{ flex: 1 }}>
            <CUnitBoxName unit={unit} />
        </Stack>
    </CUnitBox>
}

function UnitXpCounter(props) {
    const { unit } = props;
    const report = useReport()
    const [xp, setXp] = useState(0)

    useEffect(() => {
        report.updateXp(unit.id, xp)
    }, [xp])

    return <CUnitBox
        color1={INFO_COLOR}
        color2={'transparent'}
        percXp={UNIT_XP_PERC(unit.xp)}
        color3={MAIN_COLOR_ACTIVE}
        unit={unit}
        Component={ListItem}>
        <Stack sx={{ flex: 1 }}>
            <CUnitBoxName unit={unit} />
        </Stack>
        <Stack direction="row" alignItems="center">
            <Remove onClick={() => { if (xp > 0) { setXp(xp - 1) } }} />
            <Typography sx={{ fontSize: 16, fontWeight: 600, color: xp > 0 ? INFO_COLOR : GREY[800], width: 20, textAlign: 'center' }}>
                {xp}
            </Typography>
            <Add onClick={() => { setXp(xp + 1) }} />
        </Stack>
    </CUnitBox >

}

function CompleteReportButton(props) {
    const report = useReport()

    return <UButton
        onClick={report.submit}
        loading={report.loading}
        variant="contained"
        endIcon={<SubjectIcon />}
        confirm="Il report una volta inviato non può essere modificato. Inviare il report?">
        Completa il report
    </UButton>
}

function WinnerInfo() {
    const report = useReport()

    return <Stack alignItems="center">
        <UIcon size={64} name="winner" />
        <Typography sx={{ color: RP_COLOR }}>
            Hai completato questa missione
        </Typography>
        <List>
            {report.match.army.rewards.map((r, idx) => <ListItem key={r.name + idx}>
                <ListItemText
                    primaryTypographyProps={{ sx: { color: RP_COLOR } }}
                    primary={r.name}
                    secondaryTypographyProps={{ sx: { color: WHITE } }}
                    secondary={r.description} />
            </ListItem>)}
        </List>
    </Stack>
}